import { Injectable } from '@angular/core';

declare let gtag: Function;

interface GAConfig {
  clientTrackingId: string;
  tenderiTrackingId: string;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private gaConfig: GAConfig = {
    clientTrackingId: 'G-6HX1BJKM8N',
    tenderiTrackingId: 'G-Y9S3F2B28T'
  };

  constructor() { }

  private getCurrentTrackingIds(): string[] {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const trackingIds: string[] = [];

    if (hostname.includes('tenderi.mk')) {
      trackingIds.push(this.gaConfig.tenderiTrackingId);
    }

    if (pathname.startsWith('/client/')) {
      trackingIds.push(this.gaConfig.clientTrackingId);
    }

    return trackingIds;
  }

  public initializeGA() {
    const trackingIds = this.getCurrentTrackingIds();
    
    trackingIds.forEach(trackingId => {
      gtag('config', trackingId);
    });
  }

  public trackEvent(eventAction: string, eventCategory: string, eventLabel?: string, value?: number) {
    const trackingIds = this.getCurrentTrackingIds();
    
    trackingIds.forEach(trackingId => {
      gtag('event', eventAction, {
        send_to: trackingId,
        event_category: eventCategory,
        event_label: eventLabel,
        value: value
      });
    });
  }

  public trackPageView(pageTitle: string, pagePath: string) {
    const trackingIds = this.getCurrentTrackingIds();
    
    trackingIds.forEach(trackingId => {
      gtag('config', trackingId, {
        page_title: pageTitle,
        page_path: pagePath
      });
    });
  }
}